import ldb from '../base/lib/ldb'

async function post(path: string, payload:any) {
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + ldb.get('ai-art-user')?.token
        },
        body: JSON.stringify({...payload, app_id: ldb.get('app-id')})
    })
    const data = await response.json()
    return data
}

async function get(path: string) {
    const response = await fetch(path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + ldb.get('ai-art-user')?.token
        }
    })
    const data = await response.json()
    return data
}

export default {
    post,
    get
}